var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-w-shadow btn-standart-2",attrs:{"type":"button"},on:{"click":_vm.action}},[_c('inline-svg',{attrs:{"src":require(`@/assets/img/Plus-Add.svg`)}}),_vm._v(" "),_c('span',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }